import { defineMessages } from 'react-intl';

export default defineMessages({
  'heading': {
    'id': 'body_data.heading',
    'defaultMessage': 'Body Data',
    'description': 'Body data page heading and title'
  },
  'intro': {
    'id': 'body_data.intro',
    'defaultMessage': 'Body data and riding preferences are captured using Ret\u00FCl Vantage technology to provide accurate sizing information and products that match you best.',
    'description': 'Body data page heading intro'
  },
  'load_error': {
    'id': 'body_data.load_error',
    'defaultMessage': 'We are unable to retrieve your Body Data at this time, please try again later.',
    'description': 'Body data page general data loading error'
  },
  'your_progress_label': {
    'id': 'body_data.your_progress_label',
    'defaultMessage': 'Your Progress',
    'description': 'Body data progress area title text'
  },
  'your_progress_completion_label': {
    'id': 'body_data.your_progress_completion_label',
    'defaultMessage': '{numComplete}/3 Complete',
    'description': 'Body data progress area number complete text'
  },
  'about_bike': {
    'id': 'body_data.about_bike',
    'defaultMessage': 'Ret\u00FCl Match is an in-store assessment experience that precisely measures your leg length to provide optimum bike sizing and the products that match you best.',
    'description': 'Body data bike fitting overview text'
  },
  'about_saddle': {
    'id': 'body_data.about_saddle',
    'defaultMessage': 'Ret\u00FCl Match is an immersive in-store experience that leverages the Ret\u00FCl Digital Sitbone Device to capture your sitbone width with digital pressure map technology to provide accurate saddle sizing and saddles that match you best.',
    'description': 'Body data saddle fitting overview text'
  },
  'about_shoe': {
    'id': 'body_data.about_shoe',
    'defaultMessage': 'Ret\u00FCl Match is an immersive in-store experience that captures foot data to provide accurate arch support needs, shoe sizing and shoes that match you best.',
    'description': 'Body data shoe fitting overview text'
  },
  'session_type': {
    // may not need to be translated
    'id': 'body_data.session_type',
    'defaultMessage': 'Ret\u00FCl {sessionType}',
    'description': 'Body data session type text'
  },
  'bike_label': {
    // may not need to be translated
    'id': 'body_data.bike_label',
    'defaultMessage': 'Bike',
    'description': 'Bike text used for body data progress and information area'
  },
  'saddle_label': {
    // may not need to be translated
    'id': 'body_data.saddle_label',
    'defaultMessage': 'Saddle',
    'description': 'Saddle text used for body data progress and information area'
  },
  'shoe_label': {
    // may not need to be translated
    'id': 'body_data.shoe_label',
    'defaultMessage': 'Shoe',
    'description': 'Shoe text used for body data progress and information area'
  },
  'recommended_label': {
    'id': 'body_data.recommended_label',
    'defaultMessage': 'Recommended',
    'description': 'Recommended label for body data information area'
  },
  'starting_label': {
    'id': 'body_data.starting_label',
    'defaultMessage': 'Starting',
    'description': 'Starting label for body data information area'
  },
  'bike_size_label': {
    'id': 'body_data.bike_size_label',
    'defaultMessage': 'bike size',
    'description': 'Bike size label for body data information area'
  },
  'saddle_height_label': {
    'id': 'body_data.saddle_height_label',
    'defaultMessage': 'saddle height',
    'description': 'Saddle height label for body data information area'
  },
  'shoe_size_label': {
    'id': 'body_data.shoe_size_label',
    'defaultMessage': 'shoe size',
    'description': 'Shoe size label for body data information area'
  },
  'saddle_size_label': {
    'id': 'body_data.saddle_size_label',
    'defaultMessage': 'saddle size',
    'description': 'Saddle size label for body data information area'
  },
  'thigh_label': {
    'id': 'body_data.thigh_label',
    'defaultMessage': 'thigh',
    'description': 'Thigh label for body data information area'
  },
  'shin_label': {
    'id': 'body_data.shin_label',
    'defaultMessage': 'shin',
    'description': 'Shin label for body data information area'
  },
  'sit_bone_label': {
    'id': 'body_data.sit_bone_label',
    'defaultMessage': 'sit bone',
    'description': 'Sit bone label for body data information area'
  },
  'length_label': {
    'id': 'body_data.length_label',
    'defaultMessage': 'length',
    'description': 'Length label for body data information area'
  },
  'circumference_label': {
    'id': 'body_data.circumference_label',
    'defaultMessage': 'circumference',
    'description': 'Circumference label for body data information area'
  },
  'arch_height_label': {
    'id': 'body_data.arch_height_label',
    'defaultMessage': 'arch height',
    'description': 'Arch height label for body data information area'
  },
  'not_collected_label': {
    'id': 'body_data.not_collected_label',
    'defaultMessage': 'not collected',
    'description': 'Not collected label for body data information area'
  },
  'millimeter_symbol': {
    'id': 'body_data.millimeter_symbol',
    'defaultMessage': 'mm',
    'description': 'Millimeter symbol for sizing information'
  },
  'centimeter_symbol': {
    'id': 'body_data.centimeter_symbol',
    'defaultMessage': 'cm',
    'description': 'Centimeter symbol for sizing information'
  },
  'find_retul_technology_label': {
    'id': 'body_data.find_retul_technology',
    'defaultMessage': 'Find Ret\u00FCl Technology',
    'description': 'Find Retül technology button text'
  },
  'view_bike_matches_label': {
    'id': 'body_data.view_bike_matches_label',
    'defaultMessage': 'View Bike Matches',
    'description': 'View bike match button text'
  },
  'view_saddle_matches_label': {
    'id': 'body_data.view_saddle_matches_label',
    'defaultMessage': 'View Saddle Matches',
    'description': 'View saddle match button text'
  },
  'view_shoe_matches_label': {
    'id': 'body_data.view_shoe_matches_label',
    'defaultMessage': 'View Shoe Matches',
    'description': 'View shoe match button text'
  }
});



// WEBPACK FOOTER //
// ./src/client/pages/body-data/messages.js